import React, { useEffect, useState } from 'react';
import classnames from 'classnames';
import { useAngularService } from 'helpers/get_angular_service';
import Link from './link';
import usePermissions from 'helpers/use_permissions';

interface CommsTabsProps {
  tab: 'new_bulk_message' | 'templates' | 'sent_messages' | 'sms_replies' | 'sent_bulk_messages';
}

const CommsTabs = ({ tab }: CommsTabsProps) => {
  const $rootScope = useAngularService('$rootScope');
  const [unreadReplyCount, setUnreadReplyCount] = useState($rootScope.unreadReplyCount);
  const permissions = usePermissions();

  useEffect(() => {
    const unsubscribe = $rootScope.$on('unread_replies:loaded', (event, param) =>
      setUnreadReplyCount(param),
    );
    return unsubscribe;
  }, []);

  return (
    <div className="page-header__tabs">
      <Link
        className={classnames('page-header__item', {
          'page-header__item--active': tab === 'new_bulk_message',
        })}
        route="gym.bulkMessages.new"
      >
        New Message
      </Link>
      <Link
        className={classnames('page-header__item', {
          'page-header__item--active': tab === 'templates',
        })}
        ng-if="permissions.view_comms_templates"
        route="gym.templates.list"
      >
        Templates
      </Link>
      <Link
        className={classnames('page-header__item', {
          'page-header__item--active': tab === 'sent_messages',
        })}
        route="gym.bulkMessages.sent_messages"
      >
        Sent Messages
      </Link>
      {permissions.view_sent_bulk_messages_report && (
        <Link
          className={classnames('page-header__item', {
            'page-header__item--active': tab === 'sent_bulk_messages',
          })}
          route="gym.bulkMessages.list"
        >
          Sent Bulk Messages
        </Link>
      )}
      <Link
        className={classnames('page-header__item', {
          'page-header__item--active': tab === 'sms_replies',
        })}
        ng-if="permissions.view_sms_replies_report"
        route="gym.bulkMessages.smsReplies"
      >
        SMS Replies
        {unreadReplyCount > 0 && (
          <div className="page-header__item-counter">{unreadReplyCount}</div>
        )}
      </Link>
    </div>
  );
};

export default CommsTabs;
